import { render } from "./TabBox.vue?vue&type=template&id=4882406d&scoped=true"
import script from "./TabBox.vue?vue&type=script&lang=ts"
export * from "./TabBox.vue?vue&type=script&lang=ts"

import "./TabBox.vue?vue&type=style&index=0&id=4882406d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4882406d"

export default script